// React Hooks
import { memo, useEffect, useRef, useState } from "react";

// Google Map API
import {
  GoogleMap,
  LoadScript,
  MarkerClusterer,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";

// Map Marker Icons
import HelicopterIcon from "../../../../assets/img/Basic_red_dot.png";
import GreenHelicopterIcon from "../../../../assets/img/Aura_Logo Mark_Yellow.png";

// Static Map Data
import Operator_Map_locations from "./operator_map_details.json";

// React Router DOM
import { useNavigate } from "react-router-dom";
import React from "react";

const SimpleMap = (props: any) => {
  //
 
  var navigate = useNavigate();
  const om: any = require(`npm-overlapping-marker-spiderfier/lib/oms.min`);
  const setHeight = props.height;
  const [oms, setOms] = useState<any>(null);
  const [selectedPlace, setSelectedPlace] = useState<any>(null);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [infoOpen, setInfoOpen] = useState(false);
  const [hideHeli, setHideHeli] = useState(false);
  const [map, setMap] = useState<any>(null);

  const markerClickHandler = (event: any, place: any, marker: any) => {
    // Remember which place was clicked
    // if (infoOpen) {
    setInfoOpen(false);
    // }
    setSelectedMarker(marker);
    setSelectedPlace(place);
    setInfoOpen(true);
  };

  const setMapContainerHeight: any = setHeight ? "94vh" : "550px";
  const mapContainerStyle: any = {
    height: setMapContainerHeight,
    width: "100%",
  };
  useEffect(()=>{
    setActiveMarker(null);
  },[props])
  // Test End

  let center: any = { lat: 32.43104345, lng: -104.0942642 };
  if (props?.data?.SortedMapData?.length > 0) {
    center = {
      lat: Number(props?.data?.SortedMapData[0]?.gmap.lat),
      lng: Number(props?.data?.SortedMapData[0]?.gmap.lon),
    };
  }

  let final_new_location: any = props?.data?.SortedMapData;
  const markerRef = useRef<Marker>(null);

  const onLoad = React.useCallback(function callback(map: any) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    // const bounds = new window.google.maps.LatLngBounds({
    //   lat: -3.745,
    //   lng: -38.523
    // });
    // map.fitBounds(bounds);
    map.setZoom(5);

    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map: any) {
    setMap(null);
  }, []);

  const [activeMarker, setActiveMarker] = useState(null);

  const handleActiveMarker = (marker: any) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  return (
    <LoadScript googleMapsApiKey="AIzaSyCdsXnMXcV_vTCPjTd5tHGCi2Oed3hVKEQ">
      <GoogleMap
        onLoad={onLoad}
        onUnmount={onUnmount}
        id="marker-example"
        mapContainerStyle={mapContainerStyle}
        // zoom={10}
        center={center}
      >
        <MarkerClusterer maxZoom={15} onClick={() => setHideHeli(true)}>
          {(clusterer) => (
            <div>
              {final_new_location?.map((obj: any, i: any) => (
                <Marker
                  onClick={() => {
                    handleActiveMarker(i);
                  }}
                  ref={markerRef}
                  key={i}
                  position={{
                    lat: Number(obj.gmap.lat),
                    lng: Number(obj.gmap.lon),
                  }}
                  title={obj?.siteName}
                  clusterer={clusterer}
                  icon={
                    obj?.totalLeaks == 0 ? GreenHelicopterIcon : HelicopterIcon
                  }
                  animation={google.maps.Animation.DROP}
                  // draggable={true}
                >
                  {activeMarker === i ? (
                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                      <div className="marker-icons">
                        <i className="pi pi-camera" onClick={()=>{
                          window.open(process.env.REACT_APP_MVC_URL+"/Asset/Summary",'_blank')
                          // window.open(process.env.REACT_APP_MVC_URL+"/Asset/Create?Action=E&AssetId="+obj?.cameraID,'_blank')
                          // window.open(process.env.REACT_APP_MVC_URL + menuItem.link, '_blank');
                        }} title="Camera Information"></i>
                        <i
                          className="pi pi-map"
                          onClick={() => {
                            navigate(
                              `/aura-camera/operation-details/${obj?.siteID}/${obj?.createdOn}`
                            );
                          }}  title="Operation Details"
                        ></i>
                      </div>
                    </InfoWindow>
                  ) : null}
                </Marker>
              ))}
            </div>
          )}
        </MarkerClusterer>
        {infoOpen && selectedMarker && (
          <InfoWindow
            // position={selectedPlace}
            anchor={selectedMarker}
            onCloseClick={() => setInfoOpen(false)}
          >
            <div>{selectedPlace?.title}</div>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default memo(SimpleMap);
